export enum TABBAR_BLOCKER_ID {
  EJEMPLO_TABBAR = 1,
  EJEMPLO_TABBAR_SEGUNDO = 1,
}
